export default {
  getAll: 'ADMIN_DOCUMENTS_GET_ALL'
};
